export const LABORATORY_PDF_SELECTORS = {
  FIRST_PAGE: 'pdf-page-first',
  SECOND_PAGE: 'pdf-page-second',
  THIRD_PAGE: 'pdf-page-third',
};
